import {createApi} from "@reduxjs/toolkit/query/react";
import {fetchBaseFPNetQuery} from "@commons/utils/fetchBaseFPNetQuery";
import {addBaseQueryParams, BaseQueryParams, transformResponse} from "@commons/utils/APIParams";
import {CCNLLivelloRecord} from "@commons/mapping/SettoriCCNL";
import {ContrattiCCNLLivelli} from "@commons/mapping/DataTablesSchema";
import {config} from "@commons/config.instance";

export interface CCNLParams extends BaseQueryParams {
    codContrattoUNILAV: string | undefined;
    codContratto: string | undefined;
}

export const ULLivelliCCNLApi = createApi({
    reducerPath: 'ULLivelliCCNLApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('FPNet')}),
    endpoints: (builder) => ({

        // TABELLA_CCNL_LIVELLI http://fpnet.local/FPNet2021/sistema/unilav/ccnl/*-003/livello?auth_token=201f94ccf53ab349c37aaab5045b79bf&nowId=1675242765641&mode=DataTables&nowId=1675242765640&view=Grid
        getTabellaLivelliCCNL: builder.query<ContrattiCCNLLivelli, Partial<CCNLParams>>({
            query: (filter) => {
                let params: string[] = addBaseQueryParams(filter);
                if (filter.codContrattoUNILAV) params.push(filter.codContrattoUNILAV);
                if (filter.codContratto) params.push(filter.codContratto);

                let url = `/sistema/unilav/ccnl/${filter.codContrattoUNILAV}-${filter.codContratto}/livello`;

                return url + `${params.length > 0 ? '?' + encodeURI(params.join("&")) : ''}`;
            },
            transformResponse,
        }),

        // SINGOLO_LIVELLO_CCNL http://fpnet.local/FPNet2021/sistema/unilav/ccnl/*-003/livello/CC?auth_token=201f94ccf53ab349c37aaab5045b79bf&nowId=1675243092360&codContratto=003&codContrattoUNILAV=*
        getSingoloLivelloCCNL: builder.query<CCNLLivelloRecord, string>({
            query: (URI) => {
                return URI ? URI : `/${URI}`;
            },
            transformResponse
        }),

        deleteLivelloCCNL: builder.mutation<void, string>({
            query: (URI) => ({
                url: URI ? URI : '',
                method: 'DELETE'
            }),
        }),

        updateLivello: builder.mutation<Partial<CCNLLivelloRecord>, Partial<CCNLLivelloRecord> & Pick<CCNLLivelloRecord, 'URI'>>({
            // note: an optional `queryFn` may be used in place of `query`
            query: ({URI, ...patch}) => ({
                url: URI ? URI : '',
                method: 'PUT',
                body: patch,
            }),
            transformResponse,
        }),

        insertLivello: builder.mutation<Partial<CCNLLivelloRecord>, CCNLLivelloRecord>({
            // note: an optional `queryFn` may be used in place of `query`
            query: (payload) => ({
                url: `/sistema/unilav/ccnl/${payload.codContratto}-${payload.codContrattoUNILAV}/livello`,
                method: 'POST',
                body: payload,
            }),
            transformResponse
        }),
    }),
})
export const {
    useGetTabellaLivelliCCNLQuery,
    useLazyGetSingoloLivelloCCNLQuery,
    useInsertLivelloMutation,
    useUpdateLivelloMutation,
    useDeleteLivelloCCNLMutation
} = ULLivelliCCNLApi;
